import bus from 'lib/bus';
/**
 * @info
 *
 * *The "store/global" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind global functionality.
 *
 * *This file*
 * This file outlines "mutations". Mutations are intended
 * to be as simple as possible. All modifications to the state
 * object should happen inside a mutation function. Each
 * of these functions must be synchronous. There should be nothing
 * that has a time delay, such as an AJAX request or a setTimeout.
 */

export default {
  refreshCart(state, data) {
    if (data.errors) {
      state.cart.errors = data.errors;
    } else {
      state.cart = data;
      __GLOBAL__.cart = data;
    }
  },
  addNewProduct(state, data) {
    if (data.errors) {
      state.cart.errors = data.errors;
    } else {
      state.cart.items.push(data);
    }
  },
  openModal(state, data) {
    state.modal.current = data;
  },
  setActiveCountryCode(state, data) {
    state.activeCountryCode = data;
  },
  setCustomerFirstName(state, data) {
    state.customer.firstName = data;
  },
  setCustomerLastName(state, data) {
    state.customer.lastName = data;
  },
  setCustomerEmail(state, data) {
    state.customer.email = data;
  },
  setCustomerPhone(state, data) {
    state.customer.phone = data;
  },

  setGWPProductDelimiter(state, data) {
    state.gwp.productDelimiter = data;
  },
  setGWPLayout(state, data) {
    state.gwp.layout = data;
  },
  setGWPLoading(state, data) {
    state.gwp.loading = data;
  },
  setOnlyOneProductGWP(state, data) {
    state.gwp.onlyOneProduct = data;
  },
  setGWPStatus(state, data) {
    state.gwp.active = data;
  },
  setGWPHandle(state, data) {
    state.gwp.rewardHandle = data;
  },
  setGWPCollection(state, data) {
    state.gwp.collection = data.edges || data;
  },
  setGWPCollectionLimit(state, data) {
    state.gwp.limit = data;
  },
  setGWPCollectionData(state, data) {
    state.gwp.collection_data = data;
  },
  setGWPCollectionUpsellDismissed(state, dismissed) {
    state.gwp.collectionUpsellDismissed = dismissed;
  },
  setGWPThresholds(state, data) {
    state.gwp.thresholds = data;
  },
  setRewardCollection(state, data) {
    state.gwp.rewardCollection = data.edges || data;
  },
  setRewardCollectionLimit(state, data) {
    state.gwp.rewardLimit = data;
  },
  addRemoveProductToList(state, data) {
    if (state.gwp.userSelection.includes(data)) {
      state.gwp.userSelection = state.gwp.userSelection.filter(
        (id) => parseInt(id) !== data,
      );
      state.gwp.userAltSelection = state.gwp.userAltSelection.filter(
        (p) => p.id !== data,
      );
    } else {
      state.gwp.userSelection = [...state.gwp.userSelection, data];
    }
  },
  addRemoveAltProductToList(state, data) {
    const userSelection = [
      ...state.gwp.userAltSelection,
      ...state.cart.items.filter((p) => p.properties._is_gwp),
    ];
    const IDs = userSelection.map((p) => parseInt(p.id));
    if (IDs.includes(parseInt(data.id))) {
      state.gwp.userAltSelection = state.gwp.userAltSelection.filter(
        (p) => parseInt(p.id) !== parseInt(data.id),
      );
      state.gwp.userSelection = state.gwp.userSelection.filter(
        (id) => parseInt(id) !== data.id,
      );
      const cartIDS = state.cart.items
        .filter((p) => p.properties._gwp_prev_shadow)
        .map((p) => p.id);
      state.cart.items = state.cart.items.filter(
        (p) => !cartIDS.includes(p.id),
      );
    } else {
      data.id = parseInt(data.id);
      userSelection.push(data);
      state.gwp.userAltSelection = userSelection;
    }
  },

  removeAltProductToList(state, data) {
    state.gwp.userAltSelection = state.gwp.userAltSelection.filter(
      (p) => parseInt(p.id) !== data.id,
    );
  },

  clearUserSelection(state) {
    state.gwp.userSelection = [];
  },

  setCustomerBirthDay(state, data) {
    state.customer.birthDay = data;
  },
  setCustomerBirthMonth(state, data) {
    state.customer.birthMonth = data;
  },
  setBackInStock(state, data) {
    state.backInStock.product = data.product;
    state.backInStock.variant = data.variant;
  },
  setCustomerShade(state, data) {
    state.customer.shade = data;
  },
  setUGCSliderExistance(state) {
    state.UGC.sliderExists = true;
  },
  setCurrentProductGalleryVideo(state, data) {
    state.currentProductGalleryVideo = data;
  },

  setMarketRecommendation(state, data) {
    state.marketRecommendation = data;
  },

  // --- Metaobject-based Promotions ---
  setPromotionsLoading(state, isLoading) {
    state.promotions.loading = isLoading;
  },
  setPromotionsLoaded(state, isLoaded) {
    state.promotions.loaded = isLoaded;
  },
  setPromotionsError(state, error) {
    state.promotions.error = error;
  },
  setGWPPromotions(state, promotions) {
    state.promotions.gwp = promotions;
  },
  setSamplePromotions(state, promotions) {
    state.promotions.samples = promotions;
  },
  setAllPromotions(state, { gwp, samples }) {
    state.promotions.gwp = gwp;
    state.promotions.samples = samples;
    state.promotions.loaded = true;
    state.promotions.loading = false;
    state.promotions.error = null;
  },
  clearPromotions(state) {
    state.promotions.gwp = [];
    state.promotions.samples = [];
    state.promotions.loaded = false;
    state.promotions.error = null;
  },
};
